import "../../styles/styles.css";
import "./../../utils/fechas";

import { Col, Row, Spinner } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { getFechaFmt, getHoraFmt } from "./../../utils/fechas";

import Buzti from "../../assets/Buzti_Zaitez_carta.jpg";
import { Link } from "react-router-dom";
import cartelVizcainos from "../../assets/cartel_provisional_elkano.jpg";
import eventosService from "../../services/eventos";
import { useTranslation } from "react-i18next";

function CartaEvento({ evento }) {
  const [t, i18n] = useTranslation("global");
  const [loading, setLoading] = useState(true);
  const [aforo, setAforo] = useState();
  const [aforo2, setAforo2] = useState();
  const [categoria, setCategoria] = useState();
  const [Publico, setpublico] = useState();
  const [Compania, setCompania] = useState();
  const [isCompania, setIscompania] = useState();

  useEffect(() => {
    let eventoID = evento._id;
    async function getInfoEvento(eventoID) {
      const event = await eventosService.getEvento(eventoID);
      event.dia_fmt = getFechaFmt(event.evento.startDate, i18n.language);
      let minutes;
      let hora = new Date(event.evento.startDate).getHours();
      if (new Date(event.evento.startDate).getMinutes() < 10) {
        minutes = "0" + new Date(event.evento.startDate).getMinutes();
      } else {
        minutes = new Date(event.evento.startDate).getMinutes();
      }
      event.evento.hora_fmt = hora + ":" + minutes;
      event.hora_fmt = getHoraFmt(event.evento.startDate, i18n.language);
      event.inicio = getFechaFmt(event.evento.startDate, i18n.language);
      event.fin = getFechaFmt(event.evento.endDate, i18n.language);
      event.tickets.forEach((element) => {
        element.hora_fmt = getHoraFmt(element.startDate, i18n.language);
      });

      if (event.tickets.length > 0) {
        setAforo(event.tickets[0].amount);
      }
      setpublico(event.evento.tags[1]);
      setIscompania(event.evento.tags.length);

      if (event.evento.tags.length > 2) {
        setCompania(event.evento.tags[2]);
      }
      if (event.tickets.length > 1) {
        setAforo2(event.tickets[1].amount);
      }

      if (event.evento.category[0] !== "") {
        if (event.evento.category[0] === "talleres") {
          setCategoria(t("header.taller"));
        } else if (event.evento.category[0] === "teatro") {
          setCategoria(t("header.teatro"));
        } else if (event.evento.category[0] === "concert") {
          setCategoria(t("header.concierto"));
        } else if (event.evento.category[0] === "deporte") {
          setCategoria(t("header.espectaculo-magia"));
        } else if (
          event.evento.name === "Club de lectura adultos 1" ||
          event.evento.name === "Club de lectura adultos 2"
        ) {
          setCategoria(t("header.lectura"));
        } else if (
          event.evento.name ===
          "Vizcainos en la primera vuelta al mundo, 1519-22" || event.evento.name === "Bizkaitarrak lehen munduko biran,1519-22."
        ) {
          setCategoria(t("header.visita_guiada"));
        } else if (
          event.evento.name === "Colección permanente" || event.evento.name === "Bilduma iraunkorra"
        ) {
          setCategoria(t("header.visita_guiada"));
        } else if (
          event.evento._id === "6295c6be2af3d52a83899c3f" || event.evento._id === "6295c9522af3d52a8389a2de"
        ) {
          setCategoria(t("header.reportaje"));
        }else{
          setCategoria(event.evento.category[0]);
        }
      }
      console.log(event.evento.name);
      if (loading) {
        setLoading(false);
      }
    }
    getInfoEvento(eventoID);
  }, [evento, loading, i18n.language]);

  return (
    <React.Fragment>
      <div className="carta-evento">
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <Link to={{ pathname: "/evento/" + evento._id }}>
            <div className="overlap-groupCart">
              <Row>
                {evento._id === "624487bd04de14b13a9da6ed" || evento._id === "627cd7866f9618c20ea6647e" ? (
                  <img className="cartaEveVizcainos" src={cartelVizcainos} alt="cartaVizacainos"></img>
                ) : (
                  <img className="cartaEveVizcainos" src={evento.banner} alt="cartaVizacainos"></img>
                )}

              </Row>

              <div className="fechaEve">
                <h1 className="numberEve">{evento.dia_fmt}</h1>
              </div>

              <Row>
                <div className="cartaEve2">
                  {evento.tickets.length === 0 ||
                    evento.tickets[0].netPrice === 0 ? (
                    <div
                      className="infoEve"
                      style={{ backgroundColor: "white" }}
                    >
                      <div className="nombreEvento montserrat-semi-bold-thunder-25px">
                        {evento.name}
                      </div>
                      <Col>
                        <div>
                          {evento.name === "Club de lectura adultos 1" ? (
                            <div className="hora-1830Eve montserrat-normal-thunder-22px">
                              {t("header.horario-lectura1")} <br></br>{" "}
                              {t("header.horario-lecturaFinal")}
                            </div>
                          ) : (
                            <>
                              {evento.name === "Club de lectura adultos 2" ? (
                                <div className="hora-1830Eve montserrat-normal-thunder-22px">
                                  {t("header.horario-lectura2")} <br></br>{" "}
                                  {t("header.horario-lecturaFinal")}
                                </div>
                              ) : (
                                <>
                                  {evento.tickets.length === 0 ? (
                                    <div className="hora-1830Eve montserrat-normal-thunder-22px">
                                      <b>{t("header.hora")}</b>
                                      {evento.hora_fmt}
                                    </div>
                                  ) : (
                                    <div className="hora-1830Eve montserrat-normal-thunder-22px">
                                      <b>{t("header.hora")}</b>
                                      {evento.tickets[0].hora_fmt}
                                      {evento.tickets.length > 1 ? (
                                        <>
                                          {evento.tickets.length < 4 ? (
                                            <>
                                              {evento.tickets[0].hora_fmt ===
                                                evento.tickets[1].hora_fmt ? (
                                                <></>
                                              ) : (
                                                <>
                                                  / {evento.tickets[1].hora_fmt}
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </div>
                        {evento.ubication.location === undefined ? (
                          <div className="text-2Eve montserrat-normal-thunder-22px">
                            <b>{t("header.lugar")}</b>
                            {evento.location}
                          </div>
                        ) : (
                          <div className="text-2Eve montserrat-normal-thunder-22px">
                            <b>{t("header.lugar")}</b>
                            {evento.ubication.location}
                          </div>
                        )}

                        {isCompania > 2 ? (
                          <div className="text-2Eve montserrat-normal-thunder-22px">
                            <div>
                              <b> {t("header.compania")}:</b> {Compania}
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                        {Publico === "Infantil" ? (
                          <div className="text-2Eve montserrat-normal-thunder-22px">
                            <b>{t("header.publico")}: </b> {Publico} / Haurren
                          </div>
                        ) : (
                          <>
                            {Publico === "Familiar" ? (
                              <div className="text-2Eve montserrat-normal-thunder-22px">
                                <b>{t("header.publico")}: </b> {Publico} /
                                Familiako
                              </div>
                            ) : (
                              <>
                                {Publico === "Todos" ? (
                                  <div className="text-2Eve montserrat-normal-thunder-22px">
                                    <b>{t("header.publico")}: </b> {Publico} /
                                    Denak
                                  </div>
                                ) : (
                                  <>
                                    {Publico === "Adultos" ? (
                                      <div className="text-2Eve montserrat-normal-thunder-22px">
                                        <b>{t("header.publico")}: </b> {Publico} /
                                        Helduak
                                      </div>
                                    ) : (
                                      <div className="text-2Eve montserrat-normal-thunder-22px">
                                        <b>{t("header.publico")}: </b> {Publico} 
                                        
                                      </div>
                                    )}

                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}

                        <div className="text-2Eve montserrat-normal-thunder-22px">
                          <b>{t("header.genero")}:</b> {categoria}
                        </div>
                        {evento.tickets.length === 0 ? (
                          <div className="hora-1830Eve montserrat-normal-thunder-22px"></div>
                        ) : (
                          <div className="text-2Eve montserrat-normal-thunder-22px">
                            {evento.tickets[0].netPrice === 0 ? (
                              <div>
                                {evento.name === "Sorginak" ? (
                                  <>
                                    <b>{t("header.aforo")}:</b> 25
                                  </>
                                ) : (
                                  <>
                                    <b>{t("header.aforo")}:</b> {aforo}{" "}
                                    {evento.tickets.length > 1
                                      ? " / " + aforo2
                                      : ""}
                                  </>
                                )}
                              </div>
                            ) : (
                              <div>
                                <b>{t("header.precio")}</b>{" "}
                                {evento.tickets[0].netPrice}
                                {"€"}
                              </div>
                            )}
                          </div>
                        )}
                      </Col>
                    </div>
                  ) : (
                    <div
                      className="infoEve"
                      style={{ backgroundColor: "lightgoldenrodyellow" }}
                    >
                      <div className="nombreEvento montserrat-semi-bold-thunder-25px">
                        {evento.name}
                      </div>
                      <Col>
                        {evento.tags[0] === "Iralabarri bisitak" ||
                          evento.tags[0] === "Iralabarri familian" ? (
                          <div className="hora-1830Eve montserrat-normal-thunder-22px">
                            {t("header.todojulio")}
                          </div>
                        ) : (
                          <div>
                            {evento.tickets.length === 0 ? (
                              <div className="hora-1830Eve montserrat-normal-thunder-22px">
                                {t("header.hora")}
                                {evento.hora_fmt}
                              </div>
                            ) : (
                              <div className="hora-1830Eve montserrat-normal-thunder-22px">
                                {t("header.hora")}
                                {evento.tickets[0].hora_fmt ===
                                  evento.tickets[1].hora_fmt ? (
                                  <>{evento.tickets[0].hora_fmt}</>
                                ) : (
                                  <>
                                    {evento.tickets[0].hora_fmt}
                                    {evento.tickets.length > 1
                                      ? " / " + evento.tickets[1].hora_fmt
                                      : ""}
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        )}

                        <div className="text-2Eve montserrat-normal-thunder-22px">
                          {t("header.lugar")}
                          {evento.ubication.location}
                        </div>

                        {evento.tickets.length === 0 ? (
                          <div className="hora-1830Eve montserrat-normal-thunder-22px"></div>
                        ) : (
                          <div className="text-2Eve montserrat-normal-thunder-22px">
                            {evento.tickets[0].netPrice === 0 ? (
                              <div>
                                {t("header.precio")} {t("header.gratis")}
                              </div>
                            ) : (
                              <div>
                                {t("header.precio")}{" "}
                                {evento.tickets[0].netPrice}
                                {"€"}
                              </div>
                            )}
                          </div>
                        )}
                      </Col>
                    </div>
                  )}
                </div>
              </Row>
            </div>
          </Link>
        )}
      </div>
    </React.Fragment>
  );
}

export default CartaEvento;
